module.exports = __webpack_public_path__ + "img/soulout.cc79ebd0.png";